import { useState } from 'react';
import get from 'lodash/get';
import useProfileCommonStore from '../use-profile-common-store';
import { useProfilePortfolioManagers } from '../../../hooks/api';

const usePortfolioManagement = () => {
  const [defaultManager, setManager] = useState(null);
  const { apiConfigBase, commonState } = useProfileCommonStore();
  const { isLoaded, data } = useProfilePortfolioManagers(apiConfigBase);

  const managers =
    /* eslint-disable indent */
    isLoaded && data
      ? data.items.map(({ bio, imageFileName, name, title }) => {
        return {
          bio,
          imageFileName: imageFileName || 'default_placeholder.jpg',
          name: `${name.first} ${name.last}${
            name.suffix ? `, ${name.suffix}` : ''
          }`,
          title
        };
      })
      : [];
  /* eslint-enable indent */

  if (!defaultManager && managers.length) {
    setManager(managers[0]);
  }
  const renderPortfolioManagement = isLoaded ? managers.length > 0 : true;
  const ticker = get(commonState, 'xref.data.symbol', null);

  return {
    managers,
    defaultManager,
    ticker,
    renderPortfolioManagement
  };
};

export default usePortfolioManagement;
